import { Rule } from '@leprecoins/effector-forms';

export const arrayIncreasingRule: Rule<number[]> = {
	name: 'array-increasing',
	validate: (values: number[]) => values.every((value) => value > 0),
};
